<template>
    <div class="grid-container text-center">
        <div class="grid-x offline-container align-center-middle">
            <div class="cell offline-icon">
                <svg xmlns="http://www.w3.org/2000/svg" height="96" width="96" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path fill="#2a2a2a" d="M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM4.12 2.01c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l1.35 1.35C1.91 5.76.59 6.82.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l2.35-2.93 2.61 2.61c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 2.01z"/></svg>
            </div>
            <div class="cell title">
                <h1>Looks like you're offline</h1>
            </div>
            <p class="cell">We couldn't load the content you've requested. Please make sure you're connected to internet and try again</p>
            <div class="cell">
                <a class="button" href="" @click.prevent="loadHomepage">Try again</a>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import AppModule from '@/stores/modules/app';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';

@Component
export default class Offline extends Vue
{
    appModule!: AppModule;

    created() {
        this.appModule = getModule(AppModule, this.$store);
    }

    mounted() {
        if (this.appModule.isOnline) {
            this.$router.push('/').catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error('Navigation error:', err);
                }
            });
        }
    }

    loadHomepage() {
        // Force re-initialization of data stores
        window.location.href = '/';
    }
}
</script>
<style lang="scss">
.offline-container {
    height: 100vh;
}
</style>
